import React from 'react'
import Header from '../../../Components/Header'

function TerrainFeatures({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Terrain Features"} level={heading_size} />
            <div>
                Data
            </div>
        </>
    )
}

export default TerrainFeatures